"use client";
import React, { useState, useEffect, useRef } from "react";
import { useRouter } from "next/navigation";
import { useSearchParams } from "next/navigation";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";
import { FilterMenuIcon, SearchIcon } from "~/components/icons";
import useResourceStore from "~/stores/resource-store";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTrigger,
} from "components/ui/sheet";
import { ResourceFilters } from "~/components/pages/resources/resource-filters";

export const SearchBar = ({ topics, allResourcesData }) => {
  const [input, setInput] = useState("");
  const router = useRouter();
  const searchRef = useRef<any | null>(null);
  const searchParams = useSearchParams();

  const setFilter = useResourceStore((state) => state.setFilter);

  useEffect(() => {
    const search = searchParams.get("search");
    const type = searchParams.get("type");
    if (search) {
      setInput(search);
      setFilter("searchQuery", search);
    }
    if (type) {
      setFilter("type", type);
    }
    
  }, [searchParams, setFilter]);

  const handleSearch = () => {
    if (input !== "") {
      router.push(`/resources?search=${input}`);
      setFilter("searchQuery", input);
    } else {
      router.push(`/resources`);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <>
      <div
        className="container sticky top-0 z-50 flex w-full items-center justify-center gap-3 text-white md:h-full"
        ref={searchRef}
      >
        <div className="self-end lg:hidden">
          <Sheet>
            <SheetTrigger className="rounded-md border border-black p-2">
              <div className="h-[40px] w-[40px] ">
                <FilterMenuIcon />
              </div>
            </SheetTrigger>
            <SheetContent side="left" className="z-[11111]">
              <SheetDescription className="pt-5">
                <ResourceFilters
                  topics={topics}
                  allResourcesData={allResourcesData}
                />
              </SheetDescription>
            </SheetContent>
          </Sheet>
        </div>
        <div className="relative w-full">
          <div className="z-50 mt-[16px] w-full rounded-md bg-rainbow-diagonal p-[1px] md:mt-[32px]">
            <div className="flex w-full items-center justify-between rounded-md bg-white px-6 py-3 text-dark-gray md:justify-around md:gap-3">
              <Button
                className="flex self-center hover:bg-opacity-10"
                variant={"ghost"}
                size="icon"
                aria-label="Search"
                onClick={handleSearch}
              >
                <SearchIcon color="#70707E" size={30} />
              </Button>
              <Input
                placeholder="Search"
                className="font-p border-0 text-dark-gray shadow-none placeholder:text-dark-gray focus-visible:ring-0"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyPress}
              />
              {input && (
                <Button
                  className="flex self-center hover:bg-opacity-10"
                  variant={"ghost"}
                  size="icon"
                  aria-label="Clear"
                  onClick={() => {
                    setInput("");
                    setFilter("searchQuery", "");
                    router.push(`/resources`);
                  }}
                >
                  clear
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
